import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LogoLockup } from "./Logo";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Previous Result", to: "/morning-teer-previous-result/" },
  { label: "Common Number", to: "/morning-sunday-teer-common-number/" },
  { label: "Live Updates", to: "/blog/" },
  { label: "About Us", to: "/about/" },
  { label: "Blog", to: "/blog/" },
  { label: "Contact Us", to: "/contact/" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="header-logo-link" onClick={() => setOpen(false)}>
            <LogoLockup compact />
          </Link>

          <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
            {NAV.map((n, i) => {
              const active = n.to === pathname;
              return (
                <Link
                  key={i}
                  to={n.to}
                  data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`text-sm font-semibold transition-colors relative py-1 ${
                    active ? "text-[#ff4500]" : "text-slate-700 hover:text-[#ff4500]"
                  }`}
                >
                  {n.label}
                  {active && (
                    <span className="absolute -bottom-[21px] left-0 right-0 h-[3px] bg-[#ff4500] rounded-full" />
                  )}
                </Link>
              );
            })}
          </nav>

          <button
            data-testid="hamburger-toggle"
            className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-lg text-slate-900 hover:bg-slate-100"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-nav">
          <nav className="px-4 py-2">
            {NAV.map((n, i) => (
              <Link
                key={i}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="block px-2 py-3 text-[15px] font-semibold text-slate-800 border-b border-slate-100 last:border-0 active:bg-orange-50 rounded-md"
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
